// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2IGCp","title":"FrontImage_title__2CPWE"};